import { Typography } from "@material-ui/core";

export function PageHeader({ children }: any) {
  return <Typography variant="h4">{children}</Typography>;
}
